import { ReviewOtmStepCtrl } from './review-otm.controller';

export const ReviewOtmStepComponent = {
  controller: ReviewOtmStepCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./review-otm.html'),
};
